import styled from "styled-components";

export default styled.div`
  height: 100%;

  .calendar-component {
    height: 100%;

    .sx-react-calendar-wrapper {
      height: 100%;
    }
  }
`;
